import { Link } from 'react-router-dom'
import { useEffect, useState } from "react"
import { IMenuItem, ISection, IMenu } from '../../../../../types/menu'
import { AdminIcon } from '../../../../../components/ui/icons/common/admin'
import { CityIcon } from '../../../../../components/ui/icons/common/city'
import { PressIcon } from '../../../../../components/ui/icons/common/pressOffice'
import { TourismIcon } from '../../../../../components/ui/icons/common/tourism'
import { SubItemMenuNav } from "../SubItemMenuNav"
import { ContactIcon } from '../../../../../components/ui/icons/common/contact'
import { ChevronDown } from 'lucide-react'
import { useApp } from '../../../../../context/App'

interface Props {
	itemMenu: IMenuItem
	idActual?: number
	onChange: (id: number) => void
	onClose?: () => void
}

interface IIcon {
	title: string
	icon: JSX.Element
}

export function ItemMenuNav({ itemMenu, idActual, onChange, onClose }: Props) {
	const { getTenantUrl } = useApp()
	const [isOpen, setIsOpen] = useState<boolean>(false)

	const iconList: IIcon[] = [
		{ title: 'Administração', icon: <AdminIcon /> },
		{ title: 'Cidade', icon: <CityIcon /> },
		{ title: 'Imprensa', icon: <PressIcon /> },
		{ title: 'Turismo', icon: <TourismIcon /> },
		{ title: 'Ouvidoria', icon: <ContactIcon /> },
		{ title: 'Horários do Transporte Público', icon: <CityIcon /> },
		{ title: 'Semasa', icon: <CityIcon /> },
		{ title: 'Contato', icon: <ContactIcon /> }
	]

	const getIcon = (title: string) => {
		const found = iconList.find((item) => item.title === title)
		return found ? found.icon : <CityIcon />
	}

	useEffect(() => {
		if (itemMenu.cod_menu_secao === idActual || itemMenu.cod_menu_secao_grupo === idActual) {
			setIsOpen(true)
		} else {
			setIsOpen(false)
		}
	}, [idActual, itemMenu.cod_menu_secao, itemMenu.cod_menu_secao_grupo])

	return (
		<div className="flex flex-col border-b border-border-default/50 dark:border-border-default-dark/50">
			<button
				onClick={() => {
					const newId = itemMenu?.cod_menu_secao || itemMenu?.cod_menu_secao_grupo || 0;
					onChange(isOpen ? 0 : newId);
				}}
				className={`w-full flex items-center justify-between py-4 px-2 bg-transparent border-none cursor-pointer transition-colors ${isOpen ? 'text-primary dark:text-secondary' : 'text-on-surface-subtle dark:text-on-surface-dark-muted'}`}
				aria-expanded={isOpen}
			>
				<div className="flex items-center gap-4">
					<span className={`[&_svg]:h-5 [&_svg]:fill-secondary transform transition-transform duration-300 ${isOpen ? 'scale-110' : ''}`}>
						{getIcon(itemMenu.titulo || 'Cidade')}
					</span>
					<span className="uppercase font-bold text-xs tracking-wider">{itemMenu.titulo}</span>
				</div>
				<ChevronDown size={18} className={`transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} />
			</button>

			<div className={`overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-[62.5rem] pb-4' : 'max-h-0'}`}>
				<div className="flex flex-col pl-10 gap-2">
					{itemMenu.secoes && itemMenu.secoes.map((item: ISection, index: number) => (
						<SubItemMenuNav
							key={index}
							section={item}
							onClose={onClose}
						/>
					))}

					{itemMenu.menus && (
						<ul className="m-0 p-0 list-none flex flex-col gap-1">
							{itemMenu.menus?.map((item: IMenu, index: number) => {
								let menuNav_link = '#'
								let isInternal = false

								if (item.link === 'noticias') { menuNav_link = '/noticias'; isInternal = true; }
								else if (item.link === 'contato') { menuNav_link = '/contato'; isInternal = true; }
								else if (item.link === 'localizacao') { menuNav_link = '/localizacao'; isInternal = true; }
								else if (item.link === 'telefones') { menuNav_link = '/telefones'; isInternal = true; }
								else if (item.ref_cod_artigo) {
									menuNav_link = '/a/' + item.ref_cod_artigo
									isInternal = true
								} else if (item.ref_cod_entidade) {
									menuNav_link = '/e/' + item.ref_cod_entidade
									isInternal = true
								} else if (item.link) {
									menuNav_link = item.link
								}

								const target = item.nova_janela ? '_blank' : '_self'

								return (
									<li key={index}>
										{isInternal ? (
											<Link
												to={getTenantUrl(menuNav_link)}
												onClick={onClose}
												className="text-on-surface dark:text-on-surface-dark text-sm font-medium py-2 px-3 block rounded-lg hover:bg-surface-alt dark:hover:bg-white/5 no-underline transition-colors"
											>
												• {item.titulo}
											</Link>
										) : (
											<a
												href={getTenantUrl(menuNav_link)}
												target={target}
												onClick={() => {
													if (target !== '_blank') {
														onClose?.()
													}
												}}
												rel={target === '_blank' ? "noreferrer" : ""}
												className="text-on-surface dark:text-on-surface-dark text-sm font-medium py-2 px-3 block rounded-lg hover:bg-surface-alt dark:hover:bg-white/5 no-underline transition-colors"
											>
												• {item.titulo}
											</a>
										)}
									</li>
								)
							})}
						</ul>
					)}
				</div>
			</div>
		</div>
	)
}